/** Agent commissions page — non-English overrides */
export const panelAgentCommissionsByLang = {
  es: {
    'agent.commissions.tierExplainer': 'Alcanza el siguiente nivel a la derecha para desbloquear una recompensa única acreditada a tu saldo de comisiones.',
    'agent.commissions.rankingFootnote': 'La recompensa de nivel única se acredita la primera vez que se cumplen ambos requisitos.',
    'agent.commissions.summary.totalEarned': 'Total ganado',
    'agent.commissions.summary.thisMonth': 'Este mes',
    'agent.commissions.summary.pendingPayout': 'Pago pendiente',
    'agent.commissions.summary.totalPaidOut': 'Total pagado',
    'agent.commissions.rates.title': 'Tus tasas de comisión',
    'agent.commissions.rates.directTitle': 'Comisión directa',
    'agent.commissions.rates.directHint': 'Ganada en cada inversión de tus referidos directos',
    'agent.commissions.rates.indirectTitle': 'Comisión indirecta',
    'agent.commissions.rates.indirectHint': 'Ganada en inversiones de referidos indirectos',
    'agent.commissions.rates.scheduleLoading': 'Cargando calendario de comisiones…',
    'agent.commissions.rates.scheduleInstant': 'La comisión se acredita y puede retirarse al instante tras confirmar la inversión.',
    'agent.commissions.rates.scheduleAfterOne': 'La comisión se acredita y puede retirarse 1 día después de confirmar la inversión.',
    'agent.commissions.rates.scheduleAfterMany': 'La comisión se acredita y puede retirarse {{days}} días después de confirmar la inversión.',
    'agent.commissions.monthly.title': 'Este mes en resumen',
    'agent.commissions.monthly.subtitle': 'Actividad del equipo y comisiones acreditadas este mes.',
    'agent.commissions.monthly.teamInvested': 'Inversión total del equipo',
    'agent.commissions.monthly.activeMembers': 'Miembros activos',
    'agent.commissions.monthly.yourCommission': 'Tu comisión',
    'agent.commissions.monthly.calcTitle': 'Cómo se calcula',
    'agent.commissions.monthly.directRate': 'Tasa directa',
    'agent.commissions.monthly.directRateLine': '{{pct}} de cada inversión de referido directo',
    'agent.commissions.monthly.indirectRate': 'Tasa indirecta',
    'agent.commissions.monthly.indirectRateLine': '{{pct}} de cada inversión de referido indirecto',
    'agent.commissions.monthly.settlement': 'Liquidación',
    'agent.commissions.monthly.scheduleLoading': 'Cargando…',
    'agent.commissions.monthly.scheduleInstant': 'Al instante tras confirmación',
    'agent.commissions.monthly.scheduleAfterOne': '1 día tras confirmación',
    'agent.commissions.monthly.scheduleAfterMany': '{{days}} días tras confirmación',
    'agent.commissions.monthly.creditedSoFar': 'Acreditado este mes',
    'agent.commissions.monthly.footer': 'Cada comisión se acredita cuando vence el plazo de liquidación. Las recompensas de rango se acreditan al cumplir ambos requisitos.',
    'agent.commissions.history.title': 'Historial de comisiones',
    'agent.commissions.filter.all': 'Todos',
    'agent.commissions.filter.direct': 'Directo',
    'agent.commissions.filter.indirect': 'Indirecto',
    'agent.commissions.filter.rankReward': 'Recompensa de rango',
    'agent.commissions.source.direct': 'Directo',
    'agent.commissions.source.indirect': 'Indirecto',
    'agent.commissions.source.rankReward': 'Recompensa de rango',
    'agent.commission.status.pending': 'Pendiente',
    'agent.commission.status.paid': 'Pagado',
    'agent.commission.status.cancelled': 'Cancelado',
    'agent.commissions.history.col.date': 'Fecha',
    'agent.commissions.history.col.source': 'Origen',
    'agent.commissions.history.col.userTeam': 'Usuario / equipo',
    'agent.commissions.history.col.commission': 'Comisión',
    'agent.commissions.history.col.status': 'Estado',
    'agent.commissions.history.from': 'Desde',
    'agent.commissions.history.to': 'Hasta',
    'agent.commissions.history.clearDates': 'Borrar fechas',
    'agent.commissions.history.loading': 'Cargando historial de comisiones...',
    'agent.commissions.history.empty': 'No se encontraron comisiones.',
    'agent.commissions.history.pagination': 'Página {{page}} de {{totalPages}} · {{perPage}} por página',
    'agent.commissions.history.previous': 'Anterior',
    'agent.commissions.history.next': 'Siguiente',
  },
  de: {
    'agent.commissions.tierExplainer': 'Erreichen Sie die nächste Stufe rechts, um eine einmalige Prämie auf Ihr Provisionsguthaben freizuschalten.',
    'agent.commissions.rankingFootnote': 'Die einmalige Stufenprämie wird beim ersten Erfüllen beider Anforderungen gutgeschrieben.',
    'agent.commissions.summary.totalEarned': 'Insgesamt verdient',
    'agent.commissions.summary.thisMonth': 'Diesen Monat',
    'agent.commissions.summary.pendingPayout': 'Ausstehende Auszahlung',
    'agent.commissions.summary.totalPaidOut': 'Gesamt ausgezahlt',
    'agent.commissions.rates.title': 'Ihre Provisionssätze',
    'agent.commissions.rates.directTitle': 'Direktprovision',
    'agent.commissions.rates.directHint': 'Verdient bei jeder Investition Ihrer direkten Empfehlungen',
    'agent.commissions.rates.indirectTitle': 'Indirektprovision',
    'agent.commissions.rates.indirectHint': 'Verdient bei Investitionen indirekter Empfehlungen',
    'agent.commissions.rates.scheduleLoading': 'Provisionsplan wird geladen…',
    'agent.commissions.rates.scheduleInstant': 'Provision wird nach Investitionsbestätigung sofort gutgeschrieben und ist auszahlbar.',
    'agent.commissions.rates.scheduleAfterOne': 'Provision wird 1 Tag nach Investitionsbestätigung gutgeschrieben und ist auszahlbar.',
    'agent.commissions.rates.scheduleAfterMany': 'Provision wird {{days}} Tage nach Investitionsbestätigung gutgeschrieben und ist auszahlbar.',
    'agent.commissions.monthly.title': 'Dieser Monat im Überblick',
    'agent.commissions.monthly.subtitle': 'Live-Teamaktivität und bisher gutgeschriebene Provisionen.',
    'agent.commissions.monthly.teamInvested': 'Team-Investitionen gesamt',
    'agent.commissions.monthly.activeMembers': 'Aktive Mitglieder',
    'agent.commissions.monthly.yourCommission': 'Ihre Provision',
    'agent.commissions.monthly.calcTitle': 'Berechnung',
    'agent.commissions.monthly.directRate': 'Direktsatz',
    'agent.commissions.monthly.directRateLine': '{{pct}} jeder Direktinvestition',
    'agent.commissions.monthly.indirectRate': 'Indirektsatz',
    'agent.commissions.monthly.indirectRateLine': '{{pct}} jeder indirekten Investition',
    'agent.commissions.monthly.settlement': 'Abrechnung',
    'agent.commissions.monthly.scheduleLoading': 'Laden…',
    'agent.commissions.monthly.scheduleInstant': 'Sofort nach Bestätigung',
    'agent.commissions.monthly.scheduleAfterOne': '1 Tag nach Bestätigung',
    'agent.commissions.monthly.scheduleAfterMany': '{{days}} Tage nach Bestätigung',
    'agent.commissions.monthly.creditedSoFar': 'Bisher diesen Monat gutgeschrieben',
    'agent.commissions.monthly.footer': 'Jede Provision wird nach Ablauf der Abrechnungsfrist gutgeschrieben. Rangprämien bei Erfüllung beider Anforderungen sofort.',
    'agent.commissions.history.title': 'Provisionsverlauf',
    'agent.commissions.filter.all': 'Alle',
    'agent.commissions.filter.direct': 'Direkt',
    'agent.commissions.filter.indirect': 'Indirekt',
    'agent.commissions.filter.rankReward': 'Rangprämie',
    'agent.commissions.source.direct': 'Direkt',
    'agent.commissions.source.indirect': 'Indirekt',
    'agent.commissions.source.rankReward': 'Rangprämie',
    'agent.commission.status.pending': 'Ausstehend',
    'agent.commission.status.paid': 'Bezahlt',
    'agent.commission.status.cancelled': 'Storniert',
    'agent.commissions.history.col.date': 'Datum',
    'agent.commissions.history.col.source': 'Quelle',
    'agent.commissions.history.col.userTeam': 'Nutzer / Team',
    'agent.commissions.history.col.commission': 'Provision',
    'agent.commissions.history.col.status': 'Status',
    'agent.commissions.history.from': 'Von',
    'agent.commissions.history.to': 'Bis',
    'agent.commissions.history.clearDates': 'Daten löschen',
    'agent.commissions.history.loading': 'Provisionsverlauf wird geladen...',
    'agent.commissions.history.empty': 'Keine Provisionszeilen gefunden.',
    'agent.commissions.history.pagination': 'Seite {{page}} von {{totalPages}} · {{perPage}} pro Seite',
    'agent.commissions.history.previous': 'Zurück',
    'agent.commissions.history.next': 'Weiter',
  },
  fr: {
    'agent.commissions.tierExplainer': 'Atteignez le palier suivant à droite pour débloquer une récompense unique créditée sur votre solde de commissions.',
    'agent.commissions.rankingFootnote': 'La récompense de palier unique est créditée la première fois que les deux exigences sont remplies.',
    'agent.commissions.summary.totalEarned': 'Total gagné',
    'agent.commissions.summary.thisMonth': 'Ce mois-ci',
    'agent.commissions.summary.pendingPayout': 'Paiement en attente',
    'agent.commissions.summary.totalPaidOut': 'Total payé',
    'agent.commissions.rates.title': 'Vos taux de commission',
    'agent.commissions.rates.directTitle': 'Commission directe',
    'agent.commissions.rates.directHint': 'Gagnée sur chaque investissement de vos filleuls directs',
    'agent.commissions.rates.indirectTitle': 'Commission indirecte',
    'agent.commissions.rates.indirectHint': 'Gagnée sur les investissements des filleuls indirects',
    'agent.commissions.rates.scheduleLoading': 'Chargement du calendrier de commission…',
    'agent.commissions.rates.scheduleInstant': 'La commission est créditée et retirable instantanément après confirmation de l\'investissement.',
    'agent.commissions.rates.scheduleAfterOne': 'La commission est créditée et retirable 1 jour après confirmation de l\'investissement.',
    'agent.commissions.rates.scheduleAfterMany': 'La commission est créditée et retirable {{days}} jours après confirmation de l\'investissement.',
    'agent.commissions.monthly.title': 'Ce mois en un coup d\'œil',
    'agent.commissions.monthly.subtitle': 'Activité de l\'équipe et commissions créditées ce mois-ci.',
    'agent.commissions.monthly.teamInvested': 'Investissement total de l\'équipe',
    'agent.commissions.monthly.activeMembers': 'Membres actifs',
    'agent.commissions.monthly.yourCommission': 'Votre commission',
    'agent.commissions.monthly.calcTitle': 'Comment c\'est calculé',
    'agent.commissions.monthly.directRate': 'Taux direct',
    'agent.commissions.monthly.directRateLine': '{{pct}} de chaque investissement d\'un filleul direct',
    'agent.commissions.monthly.indirectRate': 'Taux indirect',
    'agent.commissions.monthly.indirectRateLine': '{{pct}} de chaque investissement d\'un filleul indirect',
    'agent.commissions.monthly.settlement': 'Règlement',
    'agent.commissions.monthly.scheduleLoading': 'Chargement…',
    'agent.commissions.monthly.scheduleInstant': 'Instantané à la confirmation',
    'agent.commissions.monthly.scheduleAfterOne': '1 jour après confirmation',
    'agent.commissions.monthly.scheduleAfterMany': '{{days}} jours après confirmation',
    'agent.commissions.monthly.creditedSoFar': 'Crédité ce mois-ci',
    'agent.commissions.monthly.footer': 'Chaque commission est créditée une fois le délai de règlement écoulé. Les récompenses de palier sont créditées dès que les deux exigences sont remplies.',
    'agent.commissions.history.title': 'Historique des commissions',
    'agent.commissions.filter.all': 'Tous',
    'agent.commissions.filter.direct': 'Direct',
    'agent.commissions.filter.indirect': 'Indirect',
    'agent.commissions.filter.rankReward': 'Récompense de palier',
    'agent.commissions.source.direct': 'Direct',
    'agent.commissions.source.indirect': 'Indirect',
    'agent.commissions.source.rankReward': 'Récompense de palier',
    'agent.commission.status.pending': 'En attente',
    'agent.commission.status.paid': 'Payé',
    'agent.commission.status.cancelled': 'Annulé',
    'agent.commissions.history.col.date': 'Date',
    'agent.commissions.history.col.source': 'Source',
    'agent.commissions.history.col.userTeam': 'Utilisateur / équipe',
    'agent.commissions.history.col.commission': 'Commission',
    'agent.commissions.history.col.status': 'Statut',
    'agent.commissions.history.from': 'Du',
    'agent.commissions.history.to': 'Au',
    'agent.commissions.history.clearDates': 'Effacer les dates',
    'agent.commissions.history.loading': 'Chargement de l\'historique des commissions…',
    'agent.commissions.history.empty': 'Aucune commission trouvée.',
    'agent.commissions.history.pagination': 'Page {{page}} sur {{totalPages}} · {{perPage}} par page',
    'agent.commissions.history.previous': 'Précédent',
    'agent.commissions.history.next': 'Suivant',
  },
  ar: {
    'agent.commissions.tierExplainer': 'حقق المستوى التالي على اليمين لفتح مكافأة لمرة واحدة تُضاف إلى رصيد العمولات.',
    'agent.commissions.rankingFootnote': 'تُضاف مكافأة المستوى لمرة واحدة عند استيفاء الشرطين لأول مرة.',
    'agent.commissions.summary.totalEarned': 'إجمالي الأرباح',
    'agent.commissions.summary.thisMonth': 'هذا الشهر',
    'agent.commissions.summary.pendingPayout': 'دفعة معلقة',
    'agent.commissions.summary.totalPaidOut': 'إجمالي المدفوع',
    'agent.commissions.rates.title': 'معدلات العمولة',
    'agent.commissions.rates.directTitle': 'عمولة مباشرة',
    'agent.commissions.rates.directHint': 'تُربح على كل استثمار من إحالاتك المباشرة',
    'agent.commissions.rates.indirectTitle': 'عمولة غير مباشرة',
    'agent.commissions.rates.indirectHint': 'تُربح على استثمارات الإحالات غير المباشرة',
    'agent.commissions.rates.scheduleLoading': 'جاري تحميل جدول إضافة العمولة…',
    'agent.commissions.rates.scheduleInstant': 'تُضاف العمولة ويمكن سحبها فوراً بعد تأكيد الاستثمار.',
    'agent.commissions.rates.scheduleAfterOne': 'تُضاف العمولة ويمكن سحبها بعد يوم واحد من تأكيد الاستثمار.',
    'agent.commissions.rates.scheduleAfterMany': 'تُضاف العمولة ويمكن سحبها بعد {{days}} يوماً من تأكيد الاستثمار.',
    'agent.commissions.monthly.title': 'هذا الشهر بنظرة سريعة',
    'agent.commissions.monthly.subtitle': 'نشاط الفريق المباشر والعمولات المُضافة حتى الآن هذا الشهر.',
    'agent.commissions.monthly.teamInvested': 'إجمالي استثمار الفريق',
    'agent.commissions.monthly.activeMembers': 'الأعضاء النشطون',
    'agent.commissions.monthly.yourCommission': 'عمولتك',
    'agent.commissions.monthly.calcTitle': 'كيف يُحسب',
    'agent.commissions.monthly.directRate': 'المعدل المباشر',
    'agent.commissions.monthly.directRateLine': '{{pct}} من كل استثمار لإحالة مباشرة',
    'agent.commissions.monthly.indirectRate': 'المعدل غير المباشر',
    'agent.commissions.monthly.indirectRateLine': '{{pct}} من كل استثمار لإحالة غير مباشرة',
    'agent.commissions.monthly.settlement': 'التسوية',
    'agent.commissions.monthly.scheduleLoading': 'جاري التحميل…',
    'agent.commissions.monthly.scheduleInstant': 'فوراً عند التأكيد',
    'agent.commissions.monthly.scheduleAfterOne': 'بعد يوم واحد من التأكيد',
    'agent.commissions.monthly.scheduleAfterMany': 'بعد {{days}} يوماً من التأكيد',
    'agent.commissions.monthly.creditedSoFar': 'المُضاف حتى الآن هذا الشهر',
    'agent.commissions.monthly.footer': 'تُضاف كل عمولة إلى رصيدك بعد انتهاء فترة التسوية لهذا الاستثمار. تُضاف مكافآت الرتبة فور استيفاء شرطي الإحالة المباشرة وغير المباشرة.',
    'agent.commissions.history.title': 'سجل العمولات',
    'agent.commissions.filter.all': 'الكل',
    'agent.commissions.filter.direct': 'مباشر',
    'agent.commissions.filter.indirect': 'غير مباشر',
    'agent.commissions.filter.rankReward': 'مكافأة المستوى',
    'agent.commissions.source.direct': 'مباشر',
    'agent.commissions.source.indirect': 'غير مباشر',
    'agent.commissions.source.rankReward': 'مكافأة المستوى',
    'agent.commission.status.pending': 'معلق',
    'agent.commission.status.paid': 'مدفوع',
    'agent.commission.status.cancelled': 'ملغى',
    'agent.commissions.history.col.date': 'التاريخ',
    'agent.commissions.history.col.source': 'المصدر',
    'agent.commissions.history.col.userTeam': 'المستخدم / الفريق',
    'agent.commissions.history.col.commission': 'العمولة',
    'agent.commissions.history.col.status': 'الحالة',
    'agent.commissions.history.from': 'من',
    'agent.commissions.history.to': 'إلى',
    'agent.commissions.history.clearDates': 'مسح التواريخ',
    'agent.commissions.history.loading': 'جاري تحميل سجل العمولات…',
    'agent.commissions.history.empty': 'لا توجد عمولات.',
    'agent.commissions.history.pagination': 'صفحة {{page}} من {{totalPages}} · {{perPage}} لكل صفحة',
    'agent.commissions.history.previous': 'السابق',
    'agent.commissions.history.next': 'التالي',
  },
  ja: {
    'agent.commissions.tierExplainer': '右の次のティアに到達すると、コミッション残高に一度限りの報酬が加算されます。',
    'agent.commissions.rankingFootnote': 'ティア報酬は、直接・間接の条件を初めて満たしたときに加算されます。',
    'agent.commissions.summary.totalEarned': '累計獲得',
    'agent.commissions.summary.thisMonth': '今月',
    'agent.commissions.summary.pendingPayout': '保留中の支払い',
    'agent.commissions.summary.totalPaidOut': '支払済み合計',
    'agent.commissions.rates.title': 'コミッション率',
    'agent.commissions.rates.directTitle': '直接コミッション',
    'agent.commissions.rates.directHint': '直接紹介者のすべての投資で獲得',
    'agent.commissions.rates.indirectTitle': '間接コミッション',
    'agent.commissions.rates.indirectHint': '間接紹介者の投資で獲得',
    'agent.commissions.rates.scheduleLoading': 'コミッション付与スケジュールを読み込み中…',
    'agent.commissions.rates.scheduleInstant': '投資確認後、コミッションは即時に付与され出金できます。',
    'agent.commissions.rates.scheduleAfterOne': '投資確認の1日後にコミッションが付与され、出金できます。',
    'agent.commissions.rates.scheduleAfterMany': '投資確認の{{days}}日後にコミッションが付与され、出金できます。',
    'agent.commissions.monthly.title': '今月の概要',
    'agent.commissions.monthly.subtitle': '今月のチーム活動とこれまでに付与されたコミッション。',
    'agent.commissions.monthly.teamInvested': 'チーム投資合計',
    'agent.commissions.monthly.activeMembers': 'アクティブメンバー',
    'agent.commissions.monthly.yourCommission': 'あなたのコミッション',
    'agent.commissions.monthly.calcTitle': '計算方法',
    'agent.commissions.monthly.directRate': '直接率',
    'agent.commissions.monthly.directRateLine': '直接紹介の投資ごとに{{pct}}',
    'agent.commissions.monthly.indirectRate': '間接率',
    'agent.commissions.monthly.indirectRateLine': '間接紹介の投資ごとに{{pct}}',
    'agent.commissions.monthly.settlement': '決済',
    'agent.commissions.monthly.scheduleLoading': '読み込み中…',
    'agent.commissions.monthly.scheduleInstant': '確認後すぐ',
    'agent.commissions.monthly.scheduleAfterOne': '確認後1日',
    'agent.commissions.monthly.scheduleAfterMany': '確認後{{days}}日',
    'agent.commissions.monthly.creditedSoFar': '今月これまでに付与',
    'agent.commissions.monthly.footer': '各コミッションは決済期間経過後に残高へ加算されます。ランク報酬は直接・間接の条件達成時に即時加算されます。',
    'agent.commissions.history.title': 'コミッション履歴',
    'agent.commissions.filter.all': 'すべて',
    'agent.commissions.filter.direct': '直接',
    'agent.commissions.filter.indirect': '間接',
    'agent.commissions.filter.rankReward': 'ティア報酬',
    'agent.commissions.source.direct': '直接',
    'agent.commissions.source.indirect': '間接',
    'agent.commissions.source.rankReward': 'ティア報酬',
    'agent.commission.status.pending': '保留中',
    'agent.commission.status.paid': '支払済み',
    'agent.commission.status.cancelled': 'キャンセル',
    'agent.commissions.history.col.date': '日付',
    'agent.commissions.history.col.source': 'ソース',
    'agent.commissions.history.col.userTeam': 'ユーザー / チーム',
    'agent.commissions.history.col.commission': 'コミッション',
    'agent.commissions.history.col.status': 'ステータス',
    'agent.commissions.history.from': '開始',
    'agent.commissions.history.to': '終了',
    'agent.commissions.history.clearDates': '日付をクリア',
    'agent.commissions.history.loading': 'コミッション履歴を読み込み中…',
    'agent.commissions.history.empty': 'コミッションがありません。',
    'agent.commissions.history.pagination': '{{totalPages}}ページ中{{page}}ページ · 1ページ{{perPage}}件',
    'agent.commissions.history.previous': '前へ',
    'agent.commissions.history.next': '次へ',
  },
  ko: {
    'agent.commissions.tierExplainer': '오른쪽 다음 등급에 도달하면 커미션 잔액에 일회성 보상이 적립됩니다.',
    'agent.commissions.rankingFootnote': '티어 보상은 직접·간접 조건을 처음 충족할 때 적립됩니다.',
    'agent.commissions.summary.totalEarned': '총 수익',
    'agent.commissions.summary.thisMonth': '이번 달',
    'agent.commissions.summary.pendingPayout': '대기 중인 지급',
    'agent.commissions.summary.totalPaidOut': '총 지급액',
    'agent.commissions.rates.title': '커미션 비율',
    'agent.commissions.rates.directTitle': '직접 커미션',
    'agent.commissions.rates.directHint': '직접 추천인의 모든 투자에서 적립',
    'agent.commissions.rates.indirectTitle': '간접 커미션',
    'agent.commissions.rates.indirectHint': '간접 추천인의 투자에서 적립',
    'agent.commissions.rates.scheduleLoading': '커미션 적립 일정 불러오는 중…',
    'agent.commissions.rates.scheduleInstant': '투자 확인 후 커미션이 즉시 적립되며 출금할 수 있습니다.',
    'agent.commissions.rates.scheduleAfterOne': '투자 확인 1일 후 커미션이 적립되며 출금할 수 있습니다.',
    'agent.commissions.rates.scheduleAfterMany': '투자 확인 {{days}}일 후 커미션이 적립되며 출금할 수 있습니다.',
    'agent.commissions.monthly.title': '이번 달 한눈에',
    'agent.commissions.monthly.subtitle': '이번 달 팀 활동 및 지금까지 적립된 커미션.',
    'agent.commissions.monthly.teamInvested': '팀 총 투자액',
    'agent.commissions.monthly.activeMembers': '활성 멤버',
    'agent.commissions.monthly.yourCommission': '내 커미션',
    'agent.commissions.monthly.calcTitle': '계산 방식',
    'agent.commissions.monthly.directRate': '직접 비율',
    'agent.commissions.monthly.directRateLine': '직접 추천 투자마다 {{pct}}',
    'agent.commissions.monthly.indirectRate': '간접 비율',
    'agent.commissions.monthly.indirectRateLine': '간접 추천 투자마다 {{pct}}',
    'agent.commissions.monthly.settlement': '정산',
    'agent.commissions.monthly.scheduleLoading': '불러오는 중…',
    'agent.commissions.monthly.scheduleInstant': '확인 즉시',
    'agent.commissions.monthly.scheduleAfterOne': '확인 후 1일',
    'agent.commissions.monthly.scheduleAfterMany': '확인 후 {{days}}일',
    'agent.commissions.monthly.creditedSoFar': '이번 달 지금까지 적립',
    'agent.commissions.monthly.footer': '각 커미션은 정산 기간이 지나면 잔액에 적립됩니다. 등급 보상은 직접·간접 조건 충족 시 즉시 적립됩니다.',
    'agent.commissions.history.title': '커미션 내역',
    'agent.commissions.filter.all': '전체',
    'agent.commissions.filter.direct': '직접',
    'agent.commissions.filter.indirect': '간접',
    'agent.commissions.filter.rankReward': '등급 보상',
    'agent.commissions.source.direct': '직접',
    'agent.commissions.source.indirect': '간접',
    'agent.commissions.source.rankReward': '등급 보상',
    'agent.commission.status.pending': '대기 중',
    'agent.commission.status.paid': '지급됨',
    'agent.commission.status.cancelled': '취소됨',
    'agent.commissions.history.col.date': '날짜',
    'agent.commissions.history.col.source': '출처',
    'agent.commissions.history.col.userTeam': '사용자 / 팀',
    'agent.commissions.history.col.commission': '커미션',
    'agent.commissions.history.col.status': '상태',
    'agent.commissions.history.from': '시작',
    'agent.commissions.history.to': '종료',
    'agent.commissions.history.clearDates': '날짜 지우기',
    'agent.commissions.history.loading': '커미션 내역 불러오는 중…',
    'agent.commissions.history.empty': '커미션 내역이 없습니다.',
    'agent.commissions.history.pagination': '{{totalPages}}페이지 중 {{page}}페이지 · 페이지당 {{perPage}}건',
    'agent.commissions.history.previous': '이전',
    'agent.commissions.history.next': '다음',
  },
  'zh-CN': {
    'agent.commissions.tierExplainer': '达到右侧下一等级即可解锁一次性奖励，计入佣金余额。',
    'agent.commissions.rankingFootnote': '首次同时满足直推与间推要求时，等级奖励一次性计入佣金余额。',
    'agent.commissions.summary.totalEarned': '累计收益',
    'agent.commissions.summary.thisMonth': '本月',
    'agent.commissions.summary.pendingPayout': '待支付',
    'agent.commissions.summary.totalPaidOut': '已支付总额',
    'agent.commissions.rates.title': '佣金比例',
    'agent.commissions.rates.directTitle': '直推佣金',
    'agent.commissions.rates.directHint': '来自直推用户的每笔投资',
    'agent.commissions.rates.indirectTitle': '间推佣金',
    'agent.commissions.rates.indirectHint': '来自间推用户的投资',
    'agent.commissions.rates.scheduleLoading': '正在加载佣金到账计划…',
    'agent.commissions.rates.scheduleInstant': '投资确认后佣金即时到账，可提现。',
    'agent.commissions.rates.scheduleAfterOne': '投资确认1天后佣金到账，可提现。',
    'agent.commissions.rates.scheduleAfterMany': '投资确认{{days}}天后佣金到账，可提现。',
    'agent.commissions.monthly.title': '本月概览',
    'agent.commissions.monthly.subtitle': '本月团队动态及已到账佣金。',
    'agent.commissions.monthly.teamInvested': '团队总投资',
    'agent.commissions.monthly.activeMembers': '活跃成员',
    'agent.commissions.monthly.yourCommission': '您的佣金',
    'agent.commissions.monthly.calcTitle': '计算方式',
    'agent.commissions.monthly.directRate': '直推比例',
    'agent.commissions.monthly.directRateLine': '每笔直推投资的{{pct}}',
    'agent.commissions.monthly.indirectRate': '间推比例',
    'agent.commissions.monthly.indirectRateLine': '每笔间推投资的{{pct}}',
    'agent.commissions.monthly.settlement': '结算',
    'agent.commissions.monthly.scheduleLoading': '加载中…',
    'agent.commissions.monthly.scheduleInstant': '确认后即时',
    'agent.commissions.monthly.scheduleAfterOne': '确认后1天',
    'agent.commissions.monthly.scheduleAfterMany': '确认后{{days}}天',
    'agent.commissions.monthly.creditedSoFar': '本月已到账',
    'agent.commissions.monthly.footer': '每笔佣金在结算期结束后计入余额。等级奖励在同时满足直推与间推要求时立即到账。',
    'agent.commissions.history.title': '佣金记录',
    'agent.commissions.filter.all': '全部',
    'agent.commissions.filter.direct': '直推',
    'agent.commissions.filter.indirect': '间推',
    'agent.commissions.filter.rankReward': '等级奖励',
    'agent.commissions.source.direct': '直推',
    'agent.commissions.source.indirect': '间推',
    'agent.commissions.source.rankReward': '等级奖励',
    'agent.commission.status.pending': '待处理',
    'agent.commission.status.paid': '已支付',
    'agent.commission.status.cancelled': '已取消',
    'agent.commissions.history.col.date': '日期',
    'agent.commissions.history.col.source': '来源',
    'agent.commissions.history.col.userTeam': '用户 / 团队',
    'agent.commissions.history.col.commission': '佣金',
    'agent.commissions.history.col.status': '状态',
    'agent.commissions.history.from': '从',
    'agent.commissions.history.to': '至',
    'agent.commissions.history.clearDates': '清除日期',
    'agent.commissions.history.loading': '正在加载佣金记录…',
    'agent.commissions.history.empty': '未找到佣金记录。',
    'agent.commissions.history.pagination': '第 {{page}} 页，共 {{totalPages}} 页 · 每页 {{perPage}} 条',
    'agent.commissions.history.previous': '上一页',
    'agent.commissions.history.next': '下一页',
  },
  pt: {
    'agent.commissions.tierExplainer': 'Alcance o próximo nível à direita para desbloquear uma recompensa única creditada no saldo de comissões.',
    'agent.commissions.rankingFootnote': 'A recompensa de nível única é creditada na primeira vez que ambos os requisitos são cumpridos.',
    'agent.commissions.summary.totalEarned': 'Total ganho',
    'agent.commissions.summary.thisMonth': 'Este mês',
    'agent.commissions.summary.pendingPayout': 'Pagamento pendente',
    'agent.commissions.summary.totalPaidOut': 'Total pago',
    'agent.commissions.rates.title': 'Suas taxas de comissão',
    'agent.commissions.rates.directTitle': 'Comissão direta',
    'agent.commissions.rates.directHint': 'Ganha em cada investimento dos seus indicados diretos',
    'agent.commissions.rates.indirectTitle': 'Comissão indireta',
    'agent.commissions.rates.indirectHint': 'Ganha em investimentos de indicados indiretos',
    'agent.commissions.rates.scheduleLoading': 'Carregando cronograma de comissão…',
    'agent.commissions.rates.scheduleInstant': 'A comissão é creditada e pode ser sacada instantaneamente após a confirmação do investimento.',
    'agent.commissions.rates.scheduleAfterOne': 'A comissão é creditada e pode ser sacada 1 dia após a confirmação do investimento.',
    'agent.commissions.rates.scheduleAfterMany': 'A comissão é creditada e pode ser sacada {{days}} dias após a confirmação do investimento.',
    'agent.commissions.monthly.title': 'Este mês em resumo',
    'agent.commissions.monthly.subtitle': 'Atividade da equipe e comissões creditadas neste mês.',
    'agent.commissions.monthly.teamInvested': 'Investimento total da equipe',
    'agent.commissions.monthly.activeMembers': 'Membros ativos',
    'agent.commissions.monthly.yourCommission': 'Sua comissão',
    'agent.commissions.monthly.calcTitle': 'Como é calculado',
    'agent.commissions.monthly.directRate': 'Taxa direta',
    'agent.commissions.monthly.directRateLine': '{{pct}} de cada investimento de indicação direta',
    'agent.commissions.monthly.indirectRate': 'Taxa indireta',
    'agent.commissions.monthly.indirectRateLine': '{{pct}} de cada investimento de indicação indireta',
    'agent.commissions.monthly.settlement': 'Liquidação',
    'agent.commissions.monthly.scheduleLoading': 'Carregando…',
    'agent.commissions.monthly.scheduleInstant': 'Instantâneo na confirmação',
    'agent.commissions.monthly.scheduleAfterOne': '1 dia após confirmação',
    'agent.commissions.monthly.scheduleAfterMany': '{{days}} dias após confirmação',
    'agent.commissions.monthly.creditedSoFar': 'Creditado neste mês',
    'agent.commissions.monthly.footer': 'Cada comissão é creditada após o prazo de liquidação. Recompensas de nível são creditadas ao cumprir ambos os requisitos.',
    'agent.commissions.history.title': 'Histórico de comissões',
    'agent.commissions.filter.all': 'Todos',
    'agent.commissions.filter.direct': 'Direto',
    'agent.commissions.filter.indirect': 'Indireto',
    'agent.commissions.filter.rankReward': 'Recompensa de nível',
    'agent.commissions.source.direct': 'Direto',
    'agent.commissions.source.indirect': 'Indireto',
    'agent.commissions.source.rankReward': 'Recompensa de nível',
    'agent.commission.status.pending': 'Pendente',
    'agent.commission.status.paid': 'Pago',
    'agent.commission.status.cancelled': 'Cancelado',
    'agent.commissions.history.col.date': 'Data',
    'agent.commissions.history.col.source': 'Origem',
    'agent.commissions.history.col.userTeam': 'Usuário / equipe',
    'agent.commissions.history.col.commission': 'Comissão',
    'agent.commissions.history.col.status': 'Status',
    'agent.commissions.history.from': 'De',
    'agent.commissions.history.to': 'Até',
    'agent.commissions.history.clearDates': 'Limpar datas',
    'agent.commissions.history.loading': 'Carregando histórico de comissões…',
    'agent.commissions.history.empty': 'Nenhuma comissão encontrada.',
    'agent.commissions.history.pagination': 'Página {{page}} de {{totalPages}} · {{perPage}} por página',
    'agent.commissions.history.previous': 'Anterior',
    'agent.commissions.history.next': 'Próximo',
  },
  it: {
    'agent.commissions.tierExplainer': 'Raggiungi il livello successivo a destra per sbloccare una ricompensa una tantum sul saldo commissioni.',
    'agent.commissions.rankingFootnote': 'La ricompensa di livello viene accreditata la prima volta che entrambi i requisiti sono soddisfatti.',
    'agent.commissions.summary.totalEarned': 'Totale guadagnato',
    'agent.commissions.summary.thisMonth': 'Questo mese',
    'agent.commissions.summary.pendingPayout': 'Pagamento in sospeso',
    'agent.commissions.summary.totalPaidOut': 'Totale pagato',
    'agent.commissions.rates.title': 'Le tue commissioni',
    'agent.commissions.rates.directTitle': 'Commissione diretta',
    'agent.commissions.rates.directHint': 'Guadagnata su ogni investimento dei tuoi referral diretti',
    'agent.commissions.rates.indirectTitle': 'Commissione indiretta',
    'agent.commissions.rates.indirectHint': 'Guadagnata sugli investimenti dei referral indiretti',
    'agent.commissions.rates.scheduleLoading': 'Caricamento calendario commissioni…',
    'agent.commissions.rates.scheduleInstant': 'La commissione è accreditata e prelevabile subito dopo la conferma dell\'investimento.',
    'agent.commissions.rates.scheduleAfterOne': 'La commissione è accreditata e prelevabile 1 giorno dopo la conferma dell\'investimento.',
    'agent.commissions.rates.scheduleAfterMany': 'La commissione è accreditata e prelevabile {{days}} giorni dopo la conferma dell\'investimento.',
    'agent.commissions.monthly.title': 'Questo mese in sintesi',
    'agent.commissions.monthly.subtitle': 'Attività del team e commissioni accreditate questo mese.',
    'agent.commissions.monthly.teamInvested': 'Investimento totale del team',
    'agent.commissions.monthly.activeMembers': 'Membri attivi',
    'agent.commissions.monthly.yourCommission': 'La tua commissione',
    'agent.commissions.monthly.calcTitle': 'Come si calcola',
    'agent.commissions.monthly.directRate': 'Tasso diretto',
    'agent.commissions.monthly.directRateLine': '{{pct}} di ogni investimento di referral diretto',
    'agent.commissions.monthly.indirectRate': 'Tasso indiretto',
    'agent.commissions.monthly.indirectRateLine': '{{pct}} di ogni investimento di referral indiretto',
    'agent.commissions.monthly.settlement': 'Regolamento',
    'agent.commissions.monthly.scheduleLoading': 'Caricamento…',
    'agent.commissions.monthly.scheduleInstant': 'Immediato alla conferma',
    'agent.commissions.monthly.scheduleAfterOne': '1 giorno dopo conferma',
    'agent.commissions.monthly.scheduleAfterMany': '{{days}} giorni dopo conferma',
    'agent.commissions.monthly.creditedSoFar': 'Accreditato questo mese',
    'agent.commissions.monthly.footer': 'Ogni commissione è accreditata dopo il periodo di regolamento. Le ricompense di livello sono accreditate al soddisfare entrambi i requisiti.',
    'agent.commissions.history.title': 'Storico commissioni',
    'agent.commissions.filter.all': 'Tutti',
    'agent.commissions.filter.direct': 'Diretto',
    'agent.commissions.filter.indirect': 'Indiretto',
    'agent.commissions.filter.rankReward': 'Ricompensa livello',
    'agent.commissions.source.direct': 'Diretto',
    'agent.commissions.source.indirect': 'Indiretto',
    'agent.commissions.source.rankReward': 'Ricompensa livello',
    'agent.commission.status.pending': 'In sospeso',
    'agent.commission.status.paid': 'Pagato',
    'agent.commission.status.cancelled': 'Annullato',
    'agent.commissions.history.col.date': 'Data',
    'agent.commissions.history.col.source': 'Fonte',
    'agent.commissions.history.col.userTeam': 'Utente / team',
    'agent.commissions.history.col.commission': 'Commissione',
    'agent.commissions.history.col.status': 'Stato',
    'agent.commissions.history.from': 'Da',
    'agent.commissions.history.to': 'A',
    'agent.commissions.history.clearDates': 'Cancella date',
    'agent.commissions.history.loading': 'Caricamento storico commissioni…',
    'agent.commissions.history.empty': 'Nessuna commissione trovata.',
    'agent.commissions.history.pagination': 'Pagina {{page}} di {{totalPages}} · {{perPage}} per pagina',
    'agent.commissions.history.previous': 'Precedente',
    'agent.commissions.history.next': 'Successivo',
  },
  ru: {
    'agent.commissions.tierExplainer': 'Достигните следующего уровня справа, чтобы получить разовую награду на баланс комиссий.',
    'agent.commissions.rankingFootnote': 'Разовая награда уровня зачисляется при первом выполнении обоих требований.',
    'agent.commissions.summary.totalEarned': 'Всего заработано',
    'agent.commissions.summary.thisMonth': 'Этот месяц',
    'agent.commissions.summary.pendingPayout': 'Ожидающая выплата',
    'agent.commissions.summary.totalPaidOut': 'Всего выплачено',
    'agent.commissions.rates.title': 'Ваши ставки комиссии',
    'agent.commissions.rates.directTitle': 'Прямая комиссия',
    'agent.commissions.rates.directHint': 'С каждого инвестирования ваших прямых рефералов',
    'agent.commissions.rates.indirectTitle': 'Косвенная комиссия',
    'agent.commissions.rates.indirectHint': 'С инвестиций косвенных рефералов',
    'agent.commissions.rates.scheduleLoading': 'Загрузка графика начисления комиссий…',
    'agent.commissions.rates.scheduleInstant': 'Комиссия зачисляется и доступна к выводу сразу после подтверждения инвестиции.',
    'agent.commissions.rates.scheduleAfterOne': 'Комиссия зачисляется и доступна к выводу через 1 день после подтверждения инвестиции.',
    'agent.commissions.rates.scheduleAfterMany': 'Комиссия зачисляется и доступна к выводу через {{days}} дн. после подтверждения инвестиции.',
    'agent.commissions.monthly.title': 'Этот месяц в обзоре',
    'agent.commissions.monthly.subtitle': 'Активность команды и комиссии, зачисленные в этом месяце.',
    'agent.commissions.monthly.teamInvested': 'Инвестиции команды всего',
    'agent.commissions.monthly.activeMembers': 'Активные участники',
    'agent.commissions.monthly.yourCommission': 'Ваша комиссия',
    'agent.commissions.monthly.calcTitle': 'Как рассчитывается',
    'agent.commissions.monthly.directRate': 'Прямая ставка',
    'agent.commissions.monthly.directRateLine': '{{pct}} с каждой инвестиции прямого реферала',
    'agent.commissions.monthly.indirectRate': 'Косвенная ставка',
    'agent.commissions.monthly.indirectRateLine': '{{pct}} с каждой инвестиции косвенного реферала',
    'agent.commissions.monthly.settlement': 'Расчёт',
    'agent.commissions.monthly.scheduleLoading': 'Загрузка…',
    'agent.commissions.monthly.scheduleInstant': 'Сразу после подтверждения',
    'agent.commissions.monthly.scheduleAfterOne': 'Через 1 день после подтверждения',
    'agent.commissions.monthly.scheduleAfterMany': 'Через {{days}} дн. после подтверждения',
    'agent.commissions.monthly.creditedSoFar': 'Зачислено в этом месяце',
    'agent.commissions.monthly.footer': 'Каждая комиссия зачисляется после окончания расчётного периода. Награды уровня — сразу при выполнении обоих требований.',
    'agent.commissions.history.title': 'История комиссий',
    'agent.commissions.filter.all': 'Все',
    'agent.commissions.filter.direct': 'Прямые',
    'agent.commissions.filter.indirect': 'Косвенные',
    'agent.commissions.filter.rankReward': 'Награда уровня',
    'agent.commissions.source.direct': 'Прямой',
    'agent.commissions.source.indirect': 'Косвенный',
    'agent.commissions.source.rankReward': 'Награда уровня',
    'agent.commission.status.pending': 'В ожидании',
    'agent.commission.status.paid': 'Выплачено',
    'agent.commission.status.cancelled': 'Отменено',
    'agent.commissions.history.col.date': 'Дата',
    'agent.commissions.history.col.source': 'Источник',
    'agent.commissions.history.col.userTeam': 'Пользователь / команда',
    'agent.commissions.history.col.commission': 'Комиссия',
    'agent.commissions.history.col.status': 'Статус',
    'agent.commissions.history.from': 'С',
    'agent.commissions.history.to': 'По',
    'agent.commissions.history.clearDates': 'Очистить даты',
    'agent.commissions.history.loading': 'Загрузка истории комиссий…',
    'agent.commissions.history.empty': 'Комиссии не найдены.',
    'agent.commissions.history.pagination': 'Страница {{page}} из {{totalPages}} · {{perPage}} на странице',
    'agent.commissions.history.previous': 'Назад',
    'agent.commissions.history.next': 'Далее',
  },
  bn: {
    'agent.commissions.tierExplainer': 'ডানদিকের পরবর্তী স্তরে পৌঁছলে কমিশন ব্যালেন্সে এককালীন পুরস্কার আনলক করুন।',
    'agent.commissions.rankingFootnote': 'প্রথমবার উভয় শর্ত পূরণে স্তর পুরস্কার জমা হয়।',
    'agent.commissions.summary.totalEarned': 'মোট আয়',
    'agent.commissions.summary.thisMonth': 'এই মাস',
    'agent.commissions.summary.pendingPayout': 'মুলতুবি পেমেন্ট',
    'agent.commissions.summary.totalPaidOut': 'মোট পরিশোধ',
    'agent.commissions.rates.title': 'আপনার কমিশন হার',
    'agent.commissions.rates.directTitle': 'সরাসরি কমিশন',
    'agent.commissions.rates.directHint': 'আপনার সরাসরি রেফারেলের প্রতিটি বিনিয়োগে অর্জিত',
    'agent.commissions.rates.indirectTitle': 'পরোক্ষ কমিশন',
    'agent.commissions.rates.indirectHint': 'পরোক্ষ রেফারেলের বিনিয়োগে অর্জিত',
    'agent.commissions.rates.scheduleLoading': 'কমিশন ক্রেডিট সময়সূচি লোড হচ্ছে…',
    'agent.commissions.rates.scheduleInstant': 'বিনিয়োগ নিশ্চিত হওয়ার পর কমিশন তাৎক্ষণিক জমা হয় এবং উত্তোলনযোগ্য।',
    'agent.commissions.rates.scheduleAfterOne': 'বিনিয়োগ নিশ্চিত হওয়ার ১ দিন পর কমিশন জমা হয় এবং উত্তোলনযোগ্য।',
    'agent.commissions.rates.scheduleAfterMany': 'বিনিয়োগ নিশ্চিত হওয়ার {{days}} দিন পর কমিশন জমা হয় এবং উত্তোলনযোগ্য।',
    'agent.commissions.monthly.title': 'এই মাস এক নজরে',
    'agent.commissions.monthly.subtitle': 'এই মাসের দলীয় কার্যকলাপ ও এখন পর্যন্ত জমা কমিশন।',
    'agent.commissions.monthly.teamInvested': 'দলের মোট বিনিয়োগ',
    'agent.commissions.monthly.activeMembers': 'সক্রিয় সদস্য',
    'agent.commissions.monthly.yourCommission': 'আপনার কমিশন',
    'agent.commissions.monthly.calcTitle': 'কীভাবে হিসাব হয়',
    'agent.commissions.monthly.directRate': 'সরাসরি হার',
    'agent.commissions.monthly.directRateLine': 'প্রতিটি সরাসরি রেফারেল বিনিয়োগের {{pct}}',
    'agent.commissions.monthly.indirectRate': 'পরোক্ষ হার',
    'agent.commissions.monthly.indirectRateLine': 'প্রতিটি পরোক্ষ রেফারেল বিনিয়োগের {{pct}}',
    'agent.commissions.monthly.settlement': 'নিষ্পত্তি',
    'agent.commissions.monthly.scheduleLoading': 'লোড হচ্ছে…',
    'agent.commissions.monthly.scheduleInstant': 'নিশ্চিতকরণে তাৎক্ষণিক',
    'agent.commissions.monthly.scheduleAfterOne': 'নিশ্চিতকরণের ১ দিন পর',
    'agent.commissions.monthly.scheduleAfterMany': 'নিশ্চিতকরণের {{days}} দিন পর',
    'agent.commissions.monthly.creditedSoFar': 'এই মাসে এখন পর্যন্ত জমা',
    'agent.commissions.monthly.footer': 'প্রতিটি কমিশন নিষ্পত্তি সময় শেষে ব্যালেন্সে জমা হয়। স্তর পুরস্কার উভয় শর্ত পূরণে সাথে সাথে জমা হয়।',
    'agent.commissions.history.title': 'কমিশন ইতিহাস',
    'agent.commissions.filter.all': 'সব',
    'agent.commissions.filter.direct': 'সরাসরি',
    'agent.commissions.filter.indirect': 'পরোক্ষ',
    'agent.commissions.filter.rankReward': 'স্তর পুরস্কার',
    'agent.commissions.source.direct': 'সরাসরি',
    'agent.commissions.source.indirect': 'পরোক্ষ',
    'agent.commissions.source.rankReward': 'স্তর পুরস্কার',
    'agent.commission.status.pending': 'মুলতুবি',
    'agent.commission.status.paid': 'পরিশোধিত',
    'agent.commission.status.cancelled': 'বাতিল',
    'agent.commissions.history.col.date': 'তারিখ',
    'agent.commissions.history.col.source': 'উৎস',
    'agent.commissions.history.col.userTeam': 'ব্যবহারকারী / দল',
    'agent.commissions.history.col.commission': 'কমিশন',
    'agent.commissions.history.col.status': 'অবস্থা',
    'agent.commissions.history.from': 'থেকে',
    'agent.commissions.history.to': 'পর্যন্ত',
    'agent.commissions.history.clearDates': 'তারিখ মুছুন',
    'agent.commissions.history.loading': 'কমিশন ইতিহাস লোড হচ্ছে…',
    'agent.commissions.history.empty': 'কোনো কমিশন পাওয়া যায়নি।',
    'agent.commissions.history.pagination': 'পৃষ্ঠা {{page}} / {{totalPages}} · প্রতি পৃষ্ঠায় {{perPage}}',
    'agent.commissions.history.previous': 'পূর্ববর্তী',
    'agent.commissions.history.next': 'পরবর্তী',
  },
  hi: {
    'agent.commissions.tierExplainer': 'दाएँ अगले स्तर तक पहुँचें और कमीशन बैलेंस में एक बार का इनाम अनलॉक करें।',
    'agent.commissions.rankingFootnote': 'पहली बार दोनों शर्तें पूरी करने पर स्तर इनाम जमा होता है।',
    'agent.commissions.summary.totalEarned': 'कुल कमाई',
    'agent.commissions.summary.thisMonth': 'इस महीने',
    'agent.commissions.summary.pendingPayout': 'लंबित भुगतान',
    'agent.commissions.summary.totalPaidOut': 'कुल भुगतान',
    'agent.commissions.rates.title': 'आपकी कमीशन दरें',
    'agent.commissions.rates.directTitle': 'प्रत्यक्ष कमीशन',
    'agent.commissions.rates.directHint': 'आपके प्रत्यक्ष रेफ़रल के हर निवेश पर',
    'agent.commissions.rates.indirectTitle': 'अप्रत्यक्ष कमीशन',
    'agent.commissions.rates.indirectHint': 'अप्रत्यक्ष रेफ़रल के निवेश पर',
    'agent.commissions.rates.scheduleLoading': 'कमीशन क्रेडिट अनुसूची लोड हो रही है…',
    'agent.commissions.rates.scheduleInstant': 'निवेश पुष्टि के बाद कमीशन तुरंत जमा होता है और निकासी योग्य है।',
    'agent.commissions.rates.scheduleAfterOne': 'निवेश पुष्टि के 1 दिन बाद कमीशन जमा होता है और निकासी योग्य है।',
    'agent.commissions.rates.scheduleAfterMany': 'निवेश पुष्टि के {{days}} दिन बाद कमीशन जमा होता है और निकासी योग्य है।',
    'agent.commissions.monthly.title': 'इस महीने एक नज़र में',
    'agent.commissions.monthly.subtitle': 'इस महीने की टीम गतिविधि और अब तक जमा कमीशन।',
    'agent.commissions.monthly.teamInvested': 'टीम का कुल निवेश',
    'agent.commissions.monthly.activeMembers': 'सक्रिय सदस्य',
    'agent.commissions.monthly.yourCommission': 'आपका कमीशन',
    'agent.commissions.monthly.calcTitle': 'गणना कैसे होती है',
    'agent.commissions.monthly.directRate': 'प्रत्यक्ष दर',
    'agent.commissions.monthly.directRateLine': 'प्रत्येक प्रत्यक्ष रेफ़रल निवेश का {{pct}}',
    'agent.commissions.monthly.indirectRate': 'अप्रत्यक्ष दर',
    'agent.commissions.monthly.indirectRateLine': 'प्रत्येक अप्रत्यक्ष रेफ़रल निवेश का {{pct}}',
    'agent.commissions.monthly.settlement': 'निपटान',
    'agent.commissions.monthly.scheduleLoading': 'लोड हो रहा है…',
    'agent.commissions.monthly.scheduleInstant': 'पुष्टि पर तुरंत',
    'agent.commissions.monthly.scheduleAfterOne': 'पुष्टि के 1 दिन बाद',
    'agent.commissions.monthly.scheduleAfterMany': 'पुष्टि के {{days}} दिन बाद',
    'agent.commissions.monthly.creditedSoFar': 'इस महीने अब तक जमा',
    'agent.commissions.monthly.footer': 'हर कमीशन निपटान अवधि पूरी होने पर बैलेंस में जमा होता है। स्तर इनाम दोनों शर्तें पूरी होते ही जमा होता है।',
    'agent.commissions.history.title': 'कमीशन इतिहास',
    'agent.commissions.filter.all': 'सभी',
    'agent.commissions.filter.direct': 'प्रत्यक्ष',
    'agent.commissions.filter.indirect': 'अप्रत्यक्ष',
    'agent.commissions.filter.rankReward': 'स्तर इनाम',
    'agent.commissions.source.direct': 'प्रत्यक्ष',
    'agent.commissions.source.indirect': 'अप्रत्यक्ष',
    'agent.commissions.source.rankReward': 'स्तर इनाम',
    'agent.commission.status.pending': 'लंबित',
    'agent.commission.status.paid': 'भुगतान किया',
    'agent.commission.status.cancelled': 'रद्द',
    'agent.commissions.history.col.date': 'तारीख',
    'agent.commissions.history.col.source': 'स्रोत',
    'agent.commissions.history.col.userTeam': 'उपयोगकर्ता / टीम',
    'agent.commissions.history.col.commission': 'कमीशन',
    'agent.commissions.history.col.status': 'स्थिति',
    'agent.commissions.history.from': 'से',
    'agent.commissions.history.to': 'तक',
    'agent.commissions.history.clearDates': 'तारीखें साफ़ करें',
    'agent.commissions.history.loading': 'कमीशन इतिहास लोड हो रहा है…',
    'agent.commissions.history.empty': 'कोई कमीशन नहीं मिला।',
    'agent.commissions.history.pagination': 'पृष्ठ {{page}} / {{totalPages}} · प्रति पृष्ठ {{perPage}}',
    'agent.commissions.history.previous': 'पिछला',
    'agent.commissions.history.next': 'अगला',
  },
};
